export const addNewPromo = {
    state: {
        allowedPromoTypes: [
            {
                name: 'Okresowa obniżka ceny',
                type: 'Promo::PeriodicPriceReduction'
            },
            {
                name: 'Wagowa okresowa obniżka ceny',
                type: 'Promo::WeightPeriodicPriceReduction'
            },
            {
                name: 'PromoMix1',
                type: 'Promo::Mix1'
            }
        ],
        steps: [
            {
                label: 'Dane podstawowe',
                active: true,
                disabled: false
            },
            {
                label: 'Wybór sklepów',
                active: false,
                disabled: true
            },
            {
                label: 'Wybór produktów',
                active: false,
                disabled: true
            },
            {
                label: 'Podsumowanie',
                active: false,
                disabled: true
            }
        ],
        form: {
            step1: {
                name: {
                    value: '',
                    required: true,
                    invalid: ''
                },
                start_at: {
                    value: '',
                    required: true,
                    invalid: ''
                },
                end_at: {
                    value: '',
                    required: true,
                    invalid: ''
                },
                marketing_id: {
                    value: '',
                    required: true,
                    invalid: ''
                },
                type: {
                    value: '',
                    required: true,
                    invalid: ''
                },
                usage_limit_per_receipt: {
                    value: ''
                },
                loyalty: {
                    value: false
                }
            },
            step2: {
                merchants: {
                    value: [],
                    required: true,
                    invalid: '',
                    errorMessage: 'Należy wybrać przynajmniej jeden sklep'
                }
            },
            step3: {
                products: {
                    value: [],
                    required: true,
                    invalid: '',
                    errorMessage: 'Należy wybrać przynajmniej jeden produkt'
                },
                product_sets: [
                    {
                        price: {
                            value: [],
                            invalid: '',
                            errorMessage: 'Należy dostosować cenę w sklepach'
                        },
                        weight: {
                            value: '',
                            required: true,
                            invalid: ''
                        },
                        products: {
                            value: [],
                            required: true,
                            invalid: '',
                            errorMessage:
                                'Należy wybrać przynajmniej jeden produkt'
                        },
                        invalid: ''
                    }
                ],
                main_image_dict_product_id: {
                    value: null,
                    required: true,
                    invalid: '',
                    errorMessage: 'Należy wybrać zdjęcie główne'
                },
                invalid: ''
            }
        },
        activationStatus: 'idle',
        activeStepIdx: 0,
        networksLimits: null,
        marketings: []
    },
    mutations: {
        SET_ACTIVATION_STATUS(state, payload) {
            state.activationStatus = payload
        },
        SET_ADDNEWPROMO_STEPS(state, payload) {
            state.steps = payload
        },
        SET_ADDNEWPROMO_FORM(state, payload) {
            state.form = payload
        },
        SET_NETWORKS_LIMITS(state, payload) {
            state.networksLimits = payload
        },
        SET_ACTIVE_STEP_IDX(state, payload) {
            state.activeStepIdx = payload
        },
        SET_ADDNEWPROMO_MARKETINGS(state, payload) {
            state.marketings = payload
        }
    },
    actions: {
        setAddNewPromoSteps({ commit }, payload) {
            commit('SET_ADDNEWPROMO_STEPS', payload)
        },
        setAddNewPromoForm({ commit }, payload) {
            commit('SET_ADDNEWPROMO_FORM', payload)
        },
        async createAndAcceptPromo({ state, commit, dispatch }, payload) {
            try {
                commit('SET_ACTIVATION_STATUS', 'loading')

                // Create promo request
                const { status, data } = await this.$api.post('promos', payload)

                if (status !== 200) {
                    // Handle error
                    throw new Error(data?.message || 'Error POST promos')
                }

                const queueId = data.data.queue_id

                const checkProgress = async () => {
                    // Check progress request
                    const { status, data } = await this.$api.get(
                        `subscriptionQueueProgress/${queueId}`
                    )

                    if (status !== 200) {
                        // Handle error
                        throw new Error(data?.message || 'Error GET progress')
                    }

                    return data.data
                }

                let progress = await checkProgress()

                const waitForCompletion = async () => {
                    const { processed, total } = progress

                    if (processed !== total) {
                        // If not done yet, wait 1.5s and check again
                        await new Promise(resolve => setTimeout(resolve, 1500))
                        progress = await checkProgress()
                        await waitForCompletion() // Recursively check again
                        return
                    }

                    /**
                     * Set total processed subscriptions and queueId
                     * in order to fetch data about all processed subscriptions
                     */
                    commit('SET_PROCESSED_SUBSCRIPTIONS_TOTAL', total)
                    commit('SET_SUBSCRIPTIONS_QUEUEID', queueId)

                    // Fetch data about all processed subscriptions
                    await Promise.all([
                        dispatch('fetchProcessedSubscriptions', {
                            type: 'successed',
                            status: 'accepted'
                        }),
                        dispatch('fetchProcessedSubscriptions', {
                            type: 'error',
                            status: 'error'
                        })
                    ])

                    commit('SET_ACTIVATION_STATUS', 'idle')
                }
                await waitForCompletion()
            } catch (err) {
                console.log(err)
                commit('SET_ACTIVATION_STATUS', 'idle')
                return { error: err }
            }
        },
        async retailersLimitsFetch({ commit }, payload) {
            try {
                const res = await this.$api.get('merchants_networks_limit', {
                    params: {
                        merchant_ids: undefined,
                        start_at: payload.start_at,
                        end_at: payload.end_at
                    }
                })
                if (res?.data?.data) {
                    commit('SET_NETWORKS_LIMITS', res.data.data)
                }
            } catch (err) {
                console.log(err)
            }
        },
        setNetworkLimits({ commit }, payload) {
            commit('SET_NETWORKS_LIMITS', payload)
        },
        async clearAddNewPromoForm({ commit }) {
            const initState = await this.$storage.getItem('initialState')
            commit('SET_ADDNEWPROMO_FORM', initState.addNewPromo.form)
            this.$storage.removeItem('addNewPromoForm')
            this.$storage.removeItem('addNewPromoSteps')
        },
        setActiveStepIdx({ commit }, payload) {
            commit('SET_ACTIVE_STEP_IDX', payload)
        },

        async setMerchantEanToNewPromoProduct({ state, dispatch }, payload) {
            try {
                const form = JSON.parse(JSON.stringify(state.form))
                const merchantIds = form.step2.merchants.value?.map(m => m.id)
                const product = form.step3.products.value.find(
                    p => p.id === payload.id
                )

                const resEans = await dispatch('fetchMerchantAltEans', {
                    params: {
                        merchant_ids: merchantIds.join(','),
                        'dict_product|id': payload.id,
                        per: 99999
                    }
                })

                if (!resEans?.data?.data?.length) return

                for (const ean of resEans.data.data) {
                    const merchantProduct = product.merchant_prices.find(
                        m => m.merchant_id === ean.merchant_id
                    )

                    if (merchantProduct) {
                        merchantProduct.alternative_ean = ean.alternative_ean
                    }
                }

                dispatch('setAddNewPromoForm', form)
            } catch (err) {
                console.log(err)
            }
        },

        async loadNewPromoMarketings({ commit, state, getters }) {
            try {
                let promo_type_id
                if (state.form.step1.type.value) {
                    promo_type_id = getters.getPromoTypes.find(
                        e => e.type === state.form.step1.type.value
                    ).id
                }
                const { data } = await this.$api.get('marketings', {
                    params: {
                        per: 99999,
                        includes: 'marketing_customer',
                        active: true,
                        promo_loyalty: state.form.step1.loyalty.value,
                        promo_type_id: promo_type_id
                    }
                })

                if (!data.data) throw new Error('No data')

                commit('SET_ADDNEWPROMO_MARKETINGS', data.data)
            } catch (err) {
                console.log(err)
            }
        },
        async fetchSubProducts({ state, dispatch }, payload) {
            try {
                const { product, setIdx, isMix } = payload
                const form = JSON.parse(JSON.stringify(state.form))
                let productData
                if (isMix) {
                    productData = form.step3.product_sets[
                        setIdx
                    ].products.value.find(prod => prod.id === product.id)
                } else {
                    productData = form.step3.products.value.find(
                        p => p.id === product.id
                    )
                }
                if (!productData) return
                const res = await this.$api.get('dict_product_eans', {
                    params: {
                        dict_product_id: product.id,
                        main: false,
                        active: true,
                        per: 99999
                    }
                })

                if (res.status !== 200 || !res.data.data) {
                    throw new Error(
                        res.data.message || 'Error GET dict_product_eans'
                    )
                }

                const subProductsData = res.data.data
                productData.linked_products_count = subProductsData.length
                productData.subProducts = subProductsData.map(el => {
                    return {
                        ...el,
                        name: productData.name,
                        image: productData.image
                    }
                })
                dispatch('setAddNewPromoForm', form)
            } catch (err) {
                console.log(err)
            }
        },

        async copyPromo({ state, commit, getters, dispatch }, payload) {
            const { promotion } = payload
            const hasSets = getters.hasProductSets(promotion.type)

            // Get initial state
            const { addNewPromo } = await this.$storage.getItem('initialState')

            // Reset new promo steps
            const initSteps = addNewPromo.steps
            if (initSteps) {
                commit('SET_ADDNEWPROMO_STEPS', initSteps)
                this.$storage.setItem('addNewPromoSteps', initSteps)
            }

            // Reset new promo form
            const storageForm = await this.$storage.getItem('addNewPromoForm')
            if (storageForm) {
                commit('SET_ADDNEWPROMO_FORM', storageForm)
            }

            // Set up new promo form
            const form = JSON.parse(JSON.stringify(addNewPromo.form))
            form.step1.name.value = promotion.name
            form.step1.type.value = promotion.type
            form.step1.marketing_id.value = promotion.marketing_id
            form.step1.usage_limit_per_receipt.value = promotion.usage_limit_per_receipt.toString()
            form.step1.loyalty.value = promotion.loyalty

            // Set up merchants
            const promoMerchantIds = promotion.subscriptions.map(el => el.merchant_id)
            const merchants = getters.getMerchants.filter(
                el => promoMerchantIds.includes(el.id)
            )
            form.step2.merchants.value = merchants

            // Set up products in format: { ...product, merchant_prices: [] }
            const productsMap = new Map()

            const productSetsMap = new Map()
            const set = form.step3.product_sets[0]
            const setCopy = JSON.parse(JSON.stringify(set))

            promotion.subscriptions.forEach(sub => {
                if (!hasSets) {
                    sub.product_subscriptions.forEach(product => {
                        const productId = product.product.dict_product_id
                        const merchantPrice = {
                            alternative_ean: product.alternative_ean,
                            merchant_id: sub.merchant_id,
                            normal_price: product.price,
                            promo_price: product.price,
                            temp_id: productId
                        }

                        if (productsMap.has(productId)) {
                            productsMap.get(productId).merchant_prices.push(merchantPrice)
                        } else {
                            productsMap.set(productId, {
                                ...product,
                                ...product.product.dict_product,
                                merchant_prices: [merchantPrice]
                            })
                        }
                    })
                } else {
                    for (const productSetSub of sub.product_set_subscriptions) {
                        const setId = productSetSub.product_set_id
                        const setProducts = productSetSub.product_set.dict_products
                        const merchantId = sub.merchant_id

                        const setPrice = {
                            merchant_id: merchantId,
                            price: productSetSub.price
                        }

                        if (productSetsMap.has(setId)) {
                            const set = productSetsMap.get(setId)
                            set.price.value.push(setPrice)

                            for (const setProduct of set.products.value) {
                                setProduct.merchant_prices.push({
                                    merchant_id: merchantId,
                                    normal_price: 0,
                                    temp_id: setProduct.id
                                })
                            }

                            continue
                        }

                        productSetsMap.set(setId, {
                            ...setCopy,
                            products: {
                                value: setProducts.map(product => {
                                    return {
                                        ...product,
                                        merchant_prices: [
                                            {
                                                merchant_id: merchantId,
                                                normal_price: 0,
                                                temp_id: product.id
                                            }
                                        ]
                                    }
                                })
                            },
                            weight: {
                                value: productSetSub.product_set.required_weight
                            },
                            price: {
                                value: [setPrice]
                            }
                        })
                    }
                }
            })

            // Convert Map back to array
            form.step3.products.value = Array.from(productsMap.values())

            form.step3.product_sets = Array.from(productSetsMap.values())

            this.$storage.setItem('addNewPromoForm', form)
        }
    },
    getters: {
        getActiveStepIdx: state => state.activeStepIdx,
        getNewPromoActivationStatus: state => state.activationStatus,
        getNewPromoSteps: state => state.steps,
        getNewPromoForm: state => state.form,
        isNewPromoTypeMix: (state, getters) =>
            getters.isMix(state.form.step1.type.value),
        isNewPromoTypeWeight: state =>
            state.form.step1.type.value.includes('Weight'),
        getNewPromoAllowedPromoTypesForSelect: state => {
            return state.allowedPromoTypes.map(type => {
                return {
                    value: type.type,
                    label: type.name
                }
            })
        },
        getNetworksLimits: state => state.networksLimits,
        getNetworksLimitsByMerchantId: state => merchantId =>
            state.networksLimits?.find(
                network => network.merchant_id === merchantId
            ),
        isNewPromoLocalCodeInvalid: (state, getters) => (merchantId, code) => {
            return !!getters.getNewPromoLocalCodesErrors.find(
                el => el.merchantId === merchantId && el.code === code
            )
        },
        getNewPromoLocalCodesErrors: (state, getters) => {
            const errors = []

            const merchantIds = state.form.step2.merchants.value?.map(m => m.id)
            const products = state.form.step3.products.value

            if (merchantIds.length && products.length) {
                merchantIds.forEach(mId => {
                    const productsArr = products.map(product => {
                        return {
                            ...product,
                            alternative_ean: product.merchant_prices.find(
                                el => el.merchant_id === mId
                            ).alternative_ean
                        }
                    })
                    const productEans = productsArr.map(
                        el => el.alternative_ean
                    )
                    const toFindDuplicates = arr =>
                        arr.filter((item, index) => arr.indexOf(item) !== index)

                    const duplicateElements = toFindDuplicates(productEans)

                    duplicateElements.forEach(el => {
                        if (!el) return
                        errors.push({
                            code: el,
                            merchantId: mId
                        })
                    })
                })
            }

            return errors
        },

        getNewPromoMarketingsForSelect: state => {
            return state.marketings.map(m => {
                return {
                    value: m.id,
                    label: m.name
                }
            })
        }
    }
}
